/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 */
import { fetchBase, FetchError, FetchSuccess } from "./managers";
import { APIGuard } from "constants/interfaces";

export interface Webpage {
  id: number;
  title: string;
  page_type: "rich_text" | "hyperlink" | "custom_html";
  page_type_text: string;
  slug: string;
  url: string;
  published: boolean;
  rich_text_content: string;
  custom_css: string;
  custom_html: string;
  metadata: {
    word_count: number;
    character_count: number;
    has_links: boolean;
    has_images: boolean;
  };
}

export interface WebpagesResponse {
  webpages: Webpage[];
}

/**
 * Fetches the list of webpages from the API
 * @returns Promise with the list of webpages
 */
export const getWebpages = async (
  eventId?: string,
): Promise<FetchSuccess<APIGuard<WebpagesResponse>>> => {
  try {
    const response = await fetchBase(`user-dashboard/webpages`, null, {
      slugTarget: "url",
      eventId,
    });
    return new FetchSuccess(response);
  } catch (error) {
    if (error instanceof Response) {
      throw new FetchError(error);
    }
    throw error;
  }
};

export const getWebpagesBySlug = async (
  slug: string,
  eventId?: string,
): Promise<FetchSuccess<APIGuard<{ page: Webpage }>>> => {
  try {
    const response = await fetchBase(
      `user-dashboard/webpages/slug/${slug}`,
      null,
      {
        slugTarget: "url",
        eventId,
      },
    );
    return new FetchSuccess(response);
  } catch (error) {
    if (error instanceof Response) {
      throw new FetchError(error);
    }
    throw error;
  }
};
